import * as React from "react";

/**
 * Header — Markenzeile über dem Inhalt.
 *
 * Das Logo nutzt die Panel-Breite, bleibt aber gedeckelt: bei sehr breitem Task
 * Pane würde eine formatfüllende Wortmarke den Inhalt erschlagen.
 */
const Header = () => (
  <div className="px-[1.6rem] pt-[1.6rem] pb-[0.8rem]">
    <img
      src="/assets/sc-eportier-logo.svg"
      className="w-full max-w-[26rem] h-auto mx-auto"
      alt="ePortier"
    />
  </div>
);

export default Header;
